import clsx from "clsx";
import type { Player } from "../../../../common/types.ts";
import i18n from "../util/i18n.ts";
import { MobileTooltip } from "./MobileTooltip.tsx";

const prefixCount = (text: string, count: number) => {
  if (count <= 1) {
    return text;
  }

  return i18n.t("seasonIcons.count", {
    ns: "ui",
    defaultValue: "{{count}}x {{text}}",
    count,
    text,
  });
};

// If no season, then check whole career
export const SeasonIcons = ({
  className,
  season,
  awards,
  playoffs,
}: {
  className?: string;
  season?: number;
  awards: Player["awards"];
  playoffs?: boolean;
}) => {
  let countChamp = 0;
  let countMVP = 0;
  let countAllStar = 0;

  for (const award of awards) {
    if (season !== undefined && award.season !== season) {
      continue;
    }

    if (playoffs) {
      if (award.type === "Won Championship") {
        countChamp += 1;
        if (season !== undefined) {
          break;
        }
      }
    } else {
      if (award.type === "Most Valuable Player") {
        countMVP += 1;
        if (season !== undefined) {
          break;
        }
      }

      // Only show these if not MVP, so no "break" statement inside
      if (award.type === "All-Star") {
        countAllStar += 1;
      }
    }
  }

  let classNameIcon;
  let iconText;
  let title;
  const titleChamp = i18n.t("seasonIcons.wonChampionship", {
    ns: "ui",
    defaultValue: "Won Championship",
  });
  const titleMVP = i18n.t("seasonIcons.mostValuablePlayer", {
    ns: "ui",
    defaultValue: "Most Valuable Player",
  });
  const titleAllStar = i18n.t("seasonIcons.allStar", {
    ns: "ui",
    defaultValue: "All-Star",
  });
  if (season !== undefined) {
    if (playoffs) {
      if (countChamp > 0) {
        title = titleChamp;
        classNameIcon = "ring";
      }
    } else {
      if (countMVP > 0) {
        title = titleMVP;
        classNameIcon = "season-icon-star text-yellow";
        iconText = "★";
      } else if (countAllStar > 0) {
        title = titleAllStar;
        classNameIcon = "season-icon-star text-body-secondary";
        iconText = "★";
      }
    }
  } else {
    if (playoffs) {
      if (countChamp > 0) {
        title = prefixCount(titleChamp, countChamp);
        classNameIcon = "ring";
      }
    } else {
      const titles = [];
      if (countMVP > 0) {
        titles.push(prefixCount(titleMVP, countMVP));
      }
      if (countAllStar > 0) {
        titles.push(prefixCount(titleAllStar, countAllStar));
      }

      if (titles.length > 0) {
        title = titles.join(
          i18n.t("seasonIcons.titleSeparator", {
            ns: "ui",
            defaultValue: ", ",
          }),
        );

        if (countMVP > 0) {
          classNameIcon = "season-icon-star text-yellow";
        } else {
          classNameIcon = "season-icon-star text-body-secondary";
        }
        iconText = "★";
      }
    }
  }

  if (title) {
    return (
      <MobileTooltip title={title}>
        <span className={clsx(classNameIcon, className)} role="img" aria-label={title}>
          {iconText}
        </span>
      </MobileTooltip>
    );
  }

  return null;
};
